export const UKAgeLimit = 18
export const localBaseUrl = 'https://localhost:4455'
